import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useFonts } from '@folklore/fonts';
import { useLocation } from 'react-router-dom';

import Header from '../partials/Header';
import Footer from '../partials/Footer';
import LightBox from '../partials/LightBox';

import { setMenuOpened as setMenuOpenedAction } from '../../actions/LayoutActions';

import styles from '../../../styles/layouts/main.scss';

const propTypes = {
    menuOpened: PropTypes.bool.isRequired,
    closeMenu: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    isPrerender: PropTypes.bool,
    fonts: PropTypes.shape({
        google: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        custom: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    }),
};

const defaultProps = {
    isPrerender: false,
    fonts: {
        google: {
            families: ['Barlow:300,400,400i,600,700,700i'],
        },
    },
};

const MainLayout = ({ menuOpened, closeMenu, fonts, children, isPrerender }) => {
    const location = useLocation().pathname;
    const withTwitter = location === '/';

    const { loaded: fontsLoaded } = useFonts(fonts);

    const innerStyle = {
        opacity: fontsLoaded || isPrerender ? 1 : 0,
    };

    const onClickLightbox = useCallback(() => closeMenu(), []);

    return (
        <div className={styles.container}>
            <Header className={styles.header} />
            <div className={styles.inner} style={innerStyle}>
                <div className={styles.content}>{children}</div>
            </div>
            <Footer withTwitter={withTwitter} className={styles.footer} />
            <LightBox opened={menuOpened} onClick={onClickLightbox} className={styles.lightbox}/>
        </div>
    );
};

MainLayout.propTypes = propTypes;
MainLayout.defaultProps = defaultProps;

const WithStateContainer = connect(
    ({ site, layout: { menuOpened } }) => ({
        isPrerender: site.isPrerender || false,
        menuOpened,
    }),
    dispatch => ({
        closeMenu: () => dispatch(setMenuOpenedAction(false)),
    }),
)(MainLayout);

export default WithStateContainer;
